import React from "react";

import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
  BooleanField,
  EditButton,
  DeleteButton,
  ImageField,
  Filter, ShowButton,
  ReferenceInput,
  SearchInput
} from "react-admin";
import { Authorizer } from "../../common/Authorizer";
import CDeleteButton from "../../common/CDeleteButton";


const Filters = props => (
  <Filter {...props} variant="outlined">
    <SearchInput variant="outlined" label="State Name" source="stateName~like" alwaysOn />
  </Filter>
);
export const StateList = (props) => {
  let propsObj = { ...props };
    if (propsObj.permissions) {
        let resourcename = `/${props.resource}`;
        let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
        if (myPermissions.length > 0) {
            let p = myPermissions[0];
            propsObj.hasList = (p.View == 1) ? true : false;
            propsObj.hasShow = (p.View == 1) ? true : false;
            propsObj.hasEdit = (p.Edit == 1) ? true : false;
            propsObj.hasDelete = (p.Delete == 1) ? true : false;
            propsObj.hasCreate = (p.Create == 1) ? true : false;
            propsObj.hasExport = (p.Export == 1) ? true : false;
        }
    }
  return (
    <List {...props} title="State List" filters={<Filters />}  >
      <Datagrid rowClick="edit">
        {propsObj.hasEdit && <EditButton />}
        {!propsObj.hasEdit && propsObj.hasShow && <ShowButton />}
        {propsObj.hasDelete && <CDeleteButton {...props}/>}
        <TextField source="stateCode" label="State Code" />
        <TextField source="stateName" label="State Name" />
        <ReferenceField source="countryId" reference="countries" link={false} label="Country" >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="insertedBy" reference="users" label="Created By" link={false}>
          <TextField source="userName" />
        </ReferenceField>
        <DateField source="insertedAt" label="Created Date" />
        <ReferenceField source="updatedBy" reference="users" label="Updated By" link={false}>
          <TextField source="userName" />
        </ReferenceField>
        <DateField source="updatedAt" label="Updated Date" />
      </Datagrid>
    </List>
  );
};
